import React, { Component } from 'react'
// import moment from 'moment/moment';
// import InfiniteScroll from 'react-infinite-scroll-component';

import './table.css';

class Table extends Component {
  renderTableData() {
    let rows = this.props.rows;
    
    if(rows) {
      return rows.sort((a,b) => (new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime()) ? 1 : ((new Date(b.createdAt).getTime() > new Date(a.createdAt).getTime()) ? -1 : 0))
      .reverse().map((row, index) => {
         const { email, createdAt, statredWorkout, user } = row
         
         return (
            <div className="tr" key={index}>
              <div className="td">{email}</div>
              <div className="td">{createdAt}</div>
              <div className="th-checkbox td">
                <input className="users-checkbox" type="checkbox" checked={user && user.purchase ? user.purchase : false} onChange={() => {}}/>
              </div>
              <div className="th-checkbox td">
                <input className="users-checkbox" type="checkbox" checked={statredWorkout} onChange={() => {}}/>
              </div>
            </div>
         )
      })
    }
   }
   
   renderTableHeader() {
      return this.props.columns.map((key, index) => {
         return <div key={index} className="tableHeader th">{key}</div>
      })
   }

   render() {
    return (
      <div className="reqTable table">
        <div className="thead">
          <div className="tr">
              {this.renderTableHeader()}
                </div>
          </div>
        <div id="tbody" className="tbody">
          {this.renderTableData()}
        </div>
      </div>
      )
   }
}

export default Table;